// import { gsap } from 'gsap';
// import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

// iOS vh height helper
function setDocHeight() {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

addEventListener('resize', setDocHeight);
addEventListener('orientationchange', setDocHeight);

setDocHeight();

jQuery(document).ready(function ($) {});

// /////////////////////////////////////////////////////////////////////////////////
// ANIMATIONS
// /////////////////////////////////////////////////////////////////////////////////

// ELEMENTS -- LEFT / RIGHT / TOP REVEAL AND FADE
// /////////////////////////////////////////////////////////////////////////////////
function animateFrom(elem, direction) {
  direction = direction || 1;
  var x = 0,
    y = direction * 100;
  if (elem.classList.contains('a-from-left')) {
    x = -200;
    y = 0;
  } else if (elem.classList.contains('a-from-right')) {
    x = 200;
    y = 0;
  } else if (elem.classList.contains('a-from-top')) {
    x = 0;
    y = 100;
  }
  elem.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
  gsap.fromTo(
    elem,
    { x: x, y: y },
    {
      duration: 1.5,
      x: 0,
      y: 0,
      autoAlpha: 1,
      ease: 'power1.out',
      overwrite: 'auto'
    }
  );
}

function hide(elem) {
  gsap.set(elem, { autoAlpha: 0 });
}

function hideStagger(elem) {
  gsap.set(elem, { autoAlpha: 0, stagger: 0.3 });
}

document.addEventListener('DOMContentLoaded', function () {
  gsap.registerPlugin(ScrollTrigger);

  gsap.utils.toArray('.a-reveal').forEach(function (elem) {
    hide(elem); // assure that the element is hidden when scrolled into view

    ScrollTrigger.create({
      trigger: elem,
      onEnter: function () {
        animateFrom(elem);
      }
      // onEnterBack: function () {
      //   animateFrom(elem, -1);
      // },
      // onLeave: function () {
      //   hide(elem);
      // } // assure that the element is hidden when scrolled into view
    });
  });

  gsap.utils.toArray('.a__reveal-stagger').forEach(function (elem) {
    ScrollTrigger.create({
      trigger: elem,
      onEnter: function () {
        animateFrom(elem);
      }
    });
  });
});

// HOME
// BANNER SCROLL COLOUR CHANGE AND OPACITIES
jQuery(document).ready(function ($) {
  gsap.registerPlugin(ScrollTrigger);
  // IMPACT
  if ($('.wrapper__home').length > 0) {
    function homeIntroToImpact() {
      const $section = $('.wrapper__home');
      const $startTrigger = $('.section__our-impact');
      const $introText = $('.section__intro-block').find('*');
      const $impactText = $('.section__our-impact').find('*');

      ScrollTrigger.matchMedia({
        '(min-width: 992px)': function () {
          const blueToGrey = gsap.fromTo(
            $section,
            { backgroundColor: 'rgb(32, 36, 41)' },
            { backgroundColor: 'rgb(242,242,242)' }
          );
          const textOpacityOut = gsap.fromTo($introText, { autoAlpha: 1 }, { autoAlpha: 0 });
          const textOpacityIn = gsap.fromTo($impactText, { autoAlpha: 0 }, { autoAlpha: 1 });

          ScrollTrigger.create({
            trigger: $startTrigger,
            start: 'top 90%',
            end: 'top 15%',
            scrub: true,
            animation: blueToGrey
          });

          ScrollTrigger.create({
            trigger: $startTrigger,
            start: 'top 80%',
            end: 'top center',
            scrub: true,
            animation: textOpacityOut
          });
          ScrollTrigger.create({
            trigger: $startTrigger,
            start: 'top 70%',
            end: 'top center',
            scrub: true,
            animation: textOpacityIn
          });
        }
      });
    }

    // function homeImpactToContact() {
    //   const $section = $('.wrapper__home');
    //   const $startTrigger = $('.section__get-in-touch');

    //   ScrollTrigger.matchMedia({
    //     '(min-width: 992px)': function () {
    //       const greyToWhite = gsap.fromTo(
    //         $section,
    //         { backgroundColor: 'rgb(242,242,242)' },
    //         { backgroundColor: 'rgb(255,255,255)' }
    //       );

    //       ScrollTrigger.create({
    //         trigger: $startTrigger,
    //         start: 'top bottom',
    //         end: 'top center',
    //         scrub: true,
    //         animation: greyToWhite
    //       });
    //     }
    //   });
    // }

    // CALL SCROLL FUNCTIONS IN REVERSE ORDER
    // 2
    // homeImpactToContact();
    // 1
    // homeIntroToImpact();
  }
});

// ////////////////////////////////////////////////////////////////////////
// TEAM - BIO EXPANSIONS/CONTRACTIONS
// ////////////////////////////////////////////////////////////////////////

jQuery(document).ready(function ($) {
  $('.team__bio-wrapper').click(function () {
    if (this.classList.contains('active')) {
      $(this).next().toggleClass('active');
      $(this).find('.team__bio-label--open').toggleClass('active');
      $(this).find('.team__bio-label--close').toggleClass('active');
    } else {
      $('.team__bio-wrapper').removeClass('active');
      $('.team__bio').removeClass('active');
      $('.team__icon-wrapper').removeClass('active');
      $('.team__bio-label--open').removeClass('active');
      $('.team__bio-label--close').removeClass('active');
      $(this).toggleClass('active');
      $(this).find('.team__icon-wrapper').toggleClass('active');
      $(this).next().toggleClass('active');
      $(this).find('.team__bio-label--open').toggleClass('active');
      $(this).find('.team__bio-label--close').toggleClass('active');
    }
  });
});

// ////////////////////////////////////////////////////////////////////////
// MENU
// ////////////////////////////////////////////////////////////////////////
document.getElementById('menu').addEventListener('click', activateMenu);
let menuToggle = 1;

function activateMenu() {
  isActive() ? openMenu() : closeMenu();
}

const isActive = function () {
  if (menuToggle === 0) {
    return true;
  } else {
    return false;
  }
};

function openMenu() {
  const scrollY = document.body.style.top;
  document.body.style.position = 'relative';
  document.body.style.top = '';
  window.scrollTo(0, parseInt(scrollY || '0') * -1);

  menuToggle = 1;
}

function closeMenu() {
  document.body.style.position = 'fixed';
  document.body.style.top = `${window.scrollY}px`;
  document.body.style.width = '100%';

  menuToggle = 0;
}

// ////////////////////////////////////////////////////////////////////////
// SWIPERS
// ////////////////////////////////////////////////////////////////////////

// HOME HERO
// ////////////////////////////////////////////////////////////////////////

jQuery(document).ready(function ($) {
  if ($('.wrapper__home').length > 0) {
    // setTimeout(initHeroCoverSwiper, 0);
    // setTimeout(initHeroSwiper, 1000);

    let swiperHeroCover = new Swiper('.heroCoverSwiper', {
      slidesPerView: 1,
      centeredSlides: true,
      speed: 1200,
      parallax: true,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + '</span>';
        }
      }
    });
  }
});

function initHeroSwiper() {
  // let swiperHero = new Swiper('.heroSwiper', {
  //   slidesPerView: 1,
  //   centeredSlides: true,
  //   speed: 500,
  //   parallax: true,
  //   loop: true,
  //   autoplay: {
  //     delay: 5000,
  //     disableOnInteraction: true
  //   }
  // });
}

// HOME HERO COVER
// ////////////////////////////////////////////////////////////////////////

function initHeroCoverSwiper() {
  // let swiperHeroCover = new Swiper('.heroCoverSwiper', {
  //   slidesPerView: 1,
  //   centeredSlides: true,
  //   speed: 500,
  //   parallax: true,
  //   loop: true,
  //   autoplay: {
  //     delay: 5000,
  //     disableOnInteraction: false
  //   },
  //   pagination: {
  //     el: '.swiper-pagination',
  //     clickable: true,
  //     renderBullet: function (index, className) {
  //       return '<span class="' + className + '">' + '</span>';
  //     }
  //   },
  //   controller: {
  //     control: swiperHero
  //   }
  // });
}

// HOME PRESS
// ////////////////////////////////////////////////////////////////////////

jQuery(document).ready(function ($) {
  if ($('.wrapper__home').length > 0 || $('.wrapper__news-single').length > 0) {
    let swiper = new Swiper('.pressSwiper', {
      slidesPerView: 1,
      spaceBetween: 10,
      breakpoints: {
        375: {
          slidesPerView: 1.5,
          spaceBetween: 20
        },
        576: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 20
        },
        1100: {
          slidesPerView: 4.5,
          spaceBetween: 20
        },
        1300: {
          slidesPerView: 5.5,
          spaceBetween: 20
        },
        1700: {
          slidesPerView: 6.5,
          spaceBetween: 20
        },
        1900: {
          slidesPerView: 7.5,
          spaceBetween: 20
        }
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + '</span>';
        }
      },
      navigation: {
        // nextEl: '.swiper-button-next',
        // prevEl: '.swiper-button-prev'
        nextEl: '.press-swiper-nav--next',
        prevEl: '.press-swiper-nav--prev'
      }
    });
  }
});

jQuery(document).ready(function ($) {
  if ($('.wrapper__home').length > 0 || $('.wrapper__news-single').length > 0) {
    $(window).scroll(testScroll);
    var viewed = false;

    function isScrolledIntoView(elem) {
      var docViewTop = $(window).scrollTop();
      var docViewBottom = docViewTop + $(window).height();

      var elemTop = $(elem).offset().top;
      var elemBottom = elemTop + $(elem).height();

      return elemBottom <= docViewBottom && elemTop >= docViewTop;
    }

    function testScroll() {
      if (isScrolledIntoView($('.our-record__heading')) && !viewed) {
        viewed = true;
        $('.count-up-value').each(function () {
          $(this)
            .prop('Counter', 300)
            .animate(
              {
                Counter: $(this).text()
              },
              {
                duration: 3000,
                easing: 'easeOutCirc',
                step: function (now) {
                  $(this).text(Math.ceil(now));
                }
              }
            );
        });
      }
    }
  }
});
